import React from 'react';
import './App.css';
import 'leaflet/dist/leaflet.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import PropertyListScreen from './pages/property-list';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
          <Routes>
              <Route path="/properties" element={<PropertyListScreen/>} />
          </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
